import React from "react";
import Detail from "./Detail";
import Manage from "./Manage";

const Index = ({ disabled }) => (disabled ? <Detail /> : <Manage />);

export default Index;
